/* eslint-disable require-atomic-updates */
import ReverMedia from 'rever-media-sdk'
import store from '@/store'
import config from '@/config.js'
import uuid from 'uuid/v4'

const MAX_CONCURRENT_FETCH_CALLS = 10
const fetchQueue = []
const isTest = config.env === 'test'
let reverMediaClient = null

async function initReverMediaClient() {
  if (reverMediaClient) {
    return reverMediaClient
  }
  reverMediaClient = await ReverMedia.init({
    reverURL: `${config.api}/api/v1`,
    reverToken: store?.state?.access?.token,
    organizationId: store?.state?.access?.organizationId,
    azureStorageToken:
      store?.state?.access?.azure?.storage?.accessToken ?? null,
  })
  return reverMediaClient
}

export async function uploadMedia(file, isPublic) {
  const client = await initReverMediaClient()
  const paths = file.type.split('/')
  const fileExtension = paths[1]

  const mediaObject = await client.upload({
    file,
    fileExtension,
    fileType: file.type,
    isPublic,
  })

  return mediaObject
}

export async function getBase64(mediaObject, size) {
  const client = await initReverMediaClient()
  return await client.fetchBase64(mediaObject, {
    size,
  })
}

export async function setAzureStorageToken(newToken) {
  const client = await initReverMediaClient()
  return client.setAzureStorageToken(newToken)
}

export async function download(mediaObject) {
  const client = await initReverMediaClient()
  return client.download(mediaObject)
}

export function getImageSrc(mediaObject, size) {
  const jobId = uuid()
  return new Promise((resolve, reject) => {
    fetchOrRetry({ jobId, mediaObject, size, resolve, reject })
  })
}

async function fetchOrRetry(args) {
  if (fetchQueue.length >= MAX_CONCURRENT_FETCH_CALLS && !isTest) {
    setTimeout(() => fetchOrRetry(args), 1000)
    return
  }

  const { jobId, mediaObject, size, resolve, reject } = args

  try {
    fetchQueue.push(jobId)
    const result = await fetchToLocalPath(mediaObject, size)
    resolve(result)
  } catch (err) {
    reject(err)
  } finally {
    removeJobFromFetchQueue(jobId)
  }
}

async function fetchToLocalPath(mediaObject, size) {
  const client = await initReverMediaClient()
  return client.fetchToLocalPath(mediaObject, { size })
}

function removeJobFromFetchQueue(jobId) {
  const index = fetchQueue.findIndex(id => id === jobId)
  if (index !== -1) fetchQueue.splice(index, 1)
}
